import React, { useState, useEffect } from "react";
import PageHeader from "../shared/pageHeader/PageHeader";
import Footer from "../shared/Footer";
import Header from "../shared/header/Header";
import NavigationMenu from "../shared/navigationMenu/NavigationMenu";
import Topic2Header from "./Topic2Header";
import TopicCreate from "./TopicCreate";

const EditTopic = () => {
  return (
    <>
      <Header />
      <NavigationMenu />
      <main className="nxl-container">
        <div className="nxl-content">
          <PageHeader>
            <Topic2Header />
          </PageHeader>

          <div className="main-content">
            <div className="row">
              <TopicCreate />
            </div>
          </div>
          <Footer />
        </div>
      </main>
    </>
  );
};

export default EditTopic;
